import {
  faArrowDownAZ,
  faArrowDownZA,
} from '@fortawesome/pro-duotone-svg-icons'
import { advancedOrder, sortFolderEnum } from 'enum/folder.enum'
import { Option } from './types'

export const options: Option[] = [
  {
    label: 'advance',
    value: 'advance',
  },
  {
    label: 'name',
    value: 'name',
    icons: {
      [sortFolderEnum.asc]: faArrowDownAZ,
      [sortFolderEnum.desc]: faArrowDownZA,
    },
  },
  {
    aliasKeyLabel: 'createdAtNew',
    label: 'createdAt',
    value: 'createdAt',
  },
  {
    label: advancedOrder,
    value: advancedOrder,
  },
]

export const optionsKey =
  'administration.folders.folder.sortConfiguration.options'
